{
  "campaigns": {
    "width": 672,
    "height": 464
  },
  "order": {
    "width": 1624,
    "height": 636
  },
  "ask": {
    "width": 1624,
    "height": 988
  },
  "request": {
    "width": 720,
    "height": 288
  },
  "post": {
    "width": 720,
    "height": 1486
  },
  "dice": {
    "width": 656,
    "height": 516
  }
}
